// O selector verifica se o usuário está autenticado, analisando o estado do Redux.
export const isAuthenticated = (state) => {
    // Se existir um token no estado de autenticação, retorna 'true' (usuário autenticado)
    if (state.auth.auth.token) return true;
    
    // Caso contrário, retorna 'false' (usuário não autenticado)
    return false;
};
